// extracted by mini-css-extract-plugin
export default {"container":"_3kLvz","list":"_1rV5e","listItem":"udLr2"};